export const optionalField = () => undefined;

export const DEFAULT_LIST_PERPAGE = 25;

export const ORGANIZATION_DROPDOWN_PERPAGE = 10000;

export const ENROLLMENT_METHOD = {
    CODE: 'code',
    ELIGIBILITY: 'eligibility',
};

export const ENROLLMENT_METHOD_OPTIONS = [
    { id: ENROLLMENT_METHOD.CODE, name: 'Code' },
    { id: ENROLLMENT_METHOD.ELIGIBILITY, name: 'Eligibility' },
];

export const RESOURCES = {
    PERMISSIONS: 'permissions',
};